import React, { useState } from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import api, { formatError } from "@/lib/api";
import Seo from "@/components/Seo";
import { toast } from "sonner";

export default function Kontakt() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); setSent(true); toast.success("Nachricht gesendet"); }
    catch (err) { toast.error(formatError(err.response?.data?.detail)); }
  };
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <Seo title="Kontakt – HELIUM" description="Kontaktiere HELIUM Catering. Wir freuen uns auf deine Nachricht." />
      <span className="text-xs font-semibold uppercase tracking-wider text-[#E0243A]">Kontakt</span>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-2 font-display">Sag Hallo</h1>
      <div className="mt-8 grid lg:grid-cols-3 gap-8">
        <div className="space-y-4 text-sm text-gray-700">
          <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-[#E0243A]" /> info@helium-catering.de</div>
          <div className="flex items-center gap-3"><Phone className="w-5 h-5 text-[#E0243A]" /> +49 202 000000</div>
          <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-[#E0243A] mt-0.5" /> HELIUM Catering UG,<br />Deutschland</div>
        </div>
        <form onSubmit={submit} className="lg:col-span-2 bg-white rounded-2xl border border-gray-100 p-6 shadow-sm space-y-4">
          {sent ? <div className="text-center py-8 text-gray-700">Danke! Wir melden uns bald bei dir.</div> : <>
            <div className="grid sm:grid-cols-2 gap-4">
              <input required placeholder="Name" data-testid="contact-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="px-4 py-3 rounded-xl border border-gray-200 w-full" />
              <input required type="email" placeholder="E-Mail" data-testid="contact-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="px-4 py-3 rounded-xl border border-gray-200 w-full" />
            </div>
            <input required placeholder="Betreff" data-testid="contact-subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} className="px-4 py-3 rounded-xl border border-gray-200 w-full" />
            <textarea required placeholder="Nachricht" rows={5} data-testid="contact-message" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="px-4 py-3 rounded-xl border border-gray-200 w-full" />
            <button data-testid="contact-submit" className="inline-flex items-center gap-2 bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold px-6 py-3 rounded-xl"><Send className="w-4 h-4" /> Senden</button>
          </>}
        </form>
      </div>
    </div>
  );
}
